import { render, staticRenderFns } from "./cognac.vue?vue&type=template&id=9d413436&scoped=true"
import script from "./cognac.vue?vue&type=script&lang=js"
export * from "./cognac.vue?vue&type=script&lang=js"
import style0 from "./cognac.vue?vue&type=style&index=0&id=9d413436&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d413436",
  null
  
)

export default component.exports